var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"frown","pack":"far","size":"is-large"}})],1),_c('p',[_vm._v(_vm._s(_vm.content))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }